<template>
  <div class="mycontainer">
    <div class="itemcontent" v-if="itemlist1">
      <div class="topcontent">
        <div class="lefttitle">今日提醒</div>
        <div class="moretitle" @click="moreclick('5')">更多></div>
      </div>

      <div class="bottomcontent">
        <div class="itemclass"
             @click="getInformationById(item.id,'5')"
             v-for="(item,index) in itemlist1"
             :class="{'lastitemclass':Number(index+1)==(itemlist1.length)}">
          <div class="circle"></div>
          <div class="name textline1">{{item.enterName}}</div>
          <div class="time">{{item.pubdate}}</div>
        </div>
        </div>
    </div>
    <div class="itemcontent" v-if="itemlist2">
      <div class="topcontent">
        <div class="lefttitle">今日预警</div>
        <div class="moretitle" @click="moreclick('6')">更多></div>
      </div>

      <div class="bottomcontent">
        <div class="itemclass"
             @click="getInformationById(item.id,'6')"
             v-for="(item,index) in itemlist2"
             :class="{'lastitemclass':Number(index+1)==(itemlist2.length)}">
          <div class="circle"></div>
          <div class="name textline1">{{item.enterName}}</div>
          <div class="time">{{item.pubDate}}</div>
        </div>
      </div>
    </div>

    <div style="height: 335px;margin-bottom: 0;" class="itemcontent" v-if="itemlist3">
      <div class="topcontent">
        <div class="lefttitle">科创头条</div>
        <div class="moretitle" @click="moreclick('0')">更多></div>
      </div>

      <div class="bottomcontent">
        <div class="itemclass1"
             @click="getInformationById(item.id,'0')"
             v-for="(item,index) in itemlist3"
             :class="{'lastitemclass':Number(index+1)==(itemlist3.length)}">
          <div class="timecontent">
            <div class="time1">{{item.time1}}</div>
            <div class="time2">{{item.time2}}</div>
          </div>
          <div class="name textline1">{{item.title}}</div>
        </div>
      </div>
    </div>
    <div style="height: 335px;margin-bottom: 0;" class="itemcontent" v-if="itemlist4">
      <div class="topcontent">
        <div class="lefttitle">驻外科技机构推荐项目</div>
        <div class="moretitle" @click="moreclick('1')">更多></div>
      </div>

      <div class="bottomcontent">
        <div class="itemclass1"
             @click="getInformationById(item.id,'1')"
             v-for="(item,index) in itemlist4"
             :class="{'lastitemclass':Number(index+1)==(itemlist4.length)}">
          <div class="timecontent">
            <div class="time1">{{item.time1}}</div>
            <div class="time2">{{item.time2}}</div>
          </div>
          <div class="name textline1">{{item.title}}</div>
        </div>
      </div>
    </div>

    <div class="itemcontent1" v-if="logolist">
      <a class="logoitem" v-for="(item,index) in logolist" :href="item.url" target="_Blank">
        <img :src="logo[item.iconName]"/>
      </a>
    </div>
  </div>

</template>

<script>
    import * as api from "../../utils/api"
    import axios from "axios";
    import logo1 from "../../assets/img/logo/logo1.png"
    import logo2 from "../../assets/img/logo/logo2.png"
    import logo3 from "../../assets/img/logo/logo3.png"
    import logo4 from "../../assets/img/logo/logo4.png"
    import logo5 from "../../assets/img/logo/logo5.png"
    import logo6 from "../../assets/img/logo/logo6.png"
    import logo7 from "../../assets/img/logo/logo7.png"
    import logo8 from "../../assets/img/logo/logo8.png"
    import logo9 from "../../assets/img/logo/logo9.png"
    import logo10 from "../../assets/img/logo/logo10.png"

    export default {
      components: {},
      name: "home",
        data(){
          return{
            logo:{
              logo1:logo1, logo2:logo2, logo3:logo3,logo4:logo4,logo5:logo5,
              logo6:logo6, logo7:logo7, logo8:logo8,logo9:logo9,logo10:logo10,
            },
            loading:false,
            tabnamelist:[],
            tableData: [],
            itemlist1:[],
            logolist:[],
            type:{0:'国内科创动态,国外科创动态',1:'推荐项目',2:'通知公告',3:'国内科创动态',4:'国外科创动态'},
            itemlist2:[],
            itemlist3:[],
            itemlist4:[],

          }
        },
        mounted() {
          this.getInformationDetail('0');
          this.getInformationDetail('1');
          this.getWarningList();//今日预警
          this.getRemindList();//今日提醒
          this.getIcon();

        },
        methods:{
          getInformationDetail(typeindex) {

            this.loading=true;
            var self = this;
            api.getInformationDetail({
              type:this.type[typeindex],
              startPage:'1',
              endPage: '4'
            })
              .then(rs => {
                self.loading=false;

                if (rs.status == 200) {
                  for(var i =0;i<rs.data.list.length;i++){
                    var item = rs.data.list[i];
                    var pubdate = item.pubdate.split('-')
                    if(pubdate.length==3){
                      item.time1=pubdate[0]+'-'+pubdate[1];
                      item.time2=pubdate[2];
                    }

                    if(typeindex==0){
                      self.itemlist3=rs.data.list;
                    }else if(typeindex==1){
                      self.itemlist4=rs.data.list;
                    }
                  }


                } else {
                  self.$message.error(rs.message)

                }

              })
              .catch(err => {
                self.$message.error(err)
                self.loading=false;

              })
          },
          getIcon() {

            this.loading=true;
            var self = this;
            api.getIcon({})
              .then(rs => {
                self.loading=false;

                if (rs.status == 200) {
                   self.logolist=rs.data;

                } else {
                  self.$message.error(rs.message)

                }

              })
              .catch(err => {
                self.$message.error(err)
                self.loading=false;

              })
          },
          //预警
          getWarningList(typeindex) {

            this.loading=true;
            var self = this;
            api.getWarningList({
              startPage:'1',
              endPage: '4'
            })
              .then(rs => {
                self.loading=false;

                if (rs.status == 200) {

                   self.itemlist2=rs.data.list;

                } else {
                  self.$message.error(rs.message)

                }

              })
              .catch(err => {
                self.$message.error(err)
                self.loading=false;

              })
          },
          //今日提醒
          getRemindList() {

            this.loading=true;
            var self = this;
            api.getRemindList({
              startPage:'1',
              endPage: '4'
            })
              .then(rs => {
                self.loading=false;

                if (rs.status == 200) {

                  self.itemlist1=rs.data.list;

                } else {
                  self.$message.error(rs.message)

                }

              })
              .catch(err => {
                self.$message.error(err)
                self.loading=false;

              })
          },

          moreclick(typeIndex){
            this.$router.push({
              name: 'informationlist',
              query:{
                typeindex:typeIndex
              }
            })
          },

          getInformationById(id,typeIndex){
            this.$router.push({
              name: 'informationdetail',
              query:{
                id:id,
                typeindex:typeIndex
              }
            })
          },
        }
    }
</script>

<style lang="less" type="text/less" rel="stylesheet/less" scoped>
  .mycontainer{
    width: 100%;
    /*min-height: calc(100vh - 70px);*/
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    .itemcontent{
      width: calc(50% - 10px);
      height: 270px;
      background-color: #ffffff;
      box-shadow: 0px 2px 6px 0px
      #ebf1f4;
      border-radius: 4px;
      margin-bottom: 20px;
      .topcontent{
        display: flex;
        height: 52px;
        border-bottom: 1px solid #e6eaf0;
        padding: 0 20px;
        .lefttitle{
          width: calc(100% - 50px);
          font-size: 17px;
          line-height: 50px;
          color: #2a3138;
          font-weight: bold;
        }
        .moretitle{
          width: 50px;
          font-size: 16px;
          line-height: 50px;
          color: #545d6b;
          text-align: right;
          cursor: pointer;

        }
        .moretitle:hover{
          color:#0a7afc;
        }
      }

      .bottomcontent{

        .lastitemclass{
          border-bottom: 0 !important;

        }
        .itemclass{
          display: flex;
          height: 52px;
          border-bottom: 1px solid #e6eaf0;
          margin: 0 20px;
          cursor: pointer;
          .circle{
            width: 12px;
            height: 12px;
            background-color: #dde4f0;
            border-radius: 6px;
            margin-top: 20px;
            margin-right: 10px;
          }
          .name{
            color: #2a3138;
            font-size: 16px;
            line-height: 52px;
            width: calc(100% - 110px);
          }
          .time{
            color: #808b9e;
            font-size: 16px;
            line-height: 52px;
            text-align: right;
            width: 90px;
          }
          .timecontent{

          }


        }
        .itemclass:hover{
          .circle{
            background-color: #0a7afc;
          }
          .name{
            color: #0a7afc;
          }
          .time{
            color: #0a7afc;
          }
        }


        .itemclass1{
          display: flex;
          height: 70px;
          border-bottom: 1px solid #e6eaf0;
          margin: 0 20px;
          cursor: pointer;
          .timecontent{
            width: 60px;
            height: 70px;
            /*background-color: #dde4f0;*/
            /*border-radius: 6px;*/
            /*margin-top: 20px;*/
            margin-right: 10px;
            .time1{
              width: 100%;
              height: 20px;
              line-height: 20px;
              background-color: #e6eaf0;
              border-radius: 4px 4px 0px 0px;
              color: #2a3138;
              font-size: 12px;
              margin-top: 10px;
              text-align: center;
            }
            .time2{
              height: 30px;
              line-height: 30px;
              background-color: #f5f6fa;
              border-radius: 0 0 4px 4px;
              font-size: 18px;
              text-align: center;
              color: #2a3138;
            }
          }
          .name{
            color: #2a3138;
            font-size: 16px;
            line-height: 70px;
            width: calc(100% - 110px);
          }
        }
        .itemclass1:hover{
          .name{
            color: #0a7afc;
          }
          .time1{
            color: #0a7afc;
            background-color: #f2faff;
          }
          .time2{
            color: #fff;
            background-color: #0a7afc;
          }
        }
      }
    }

    .itemcontent1{
      width: 100%;
      display: flex;
      flex-wrap: wrap;
      .logoitem{
        width: 19%;
        height: 90px*0.9;
        /*background-color: #ffffff;*/
        display: flex;
        justify-content: center;
        align-items: center;
        margin-right: 1%;
        margin-top: 20px;
        cursor: pointer;
        img{
          width: 95%;
        }
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/views/home/home.vue